import AndroidIcon from "./icons/AndroidIcon";
import EcommerceIcon from "./icons/EcommerceIcon";
import IosIcon from "./icons/IosIcon";
import ShopifyIcon from "./icons/ShopifyIcon";
import {
  IOS,
  SHOPIFY,
  NEW_SHOPIFY,
  ECOMMERCE,
  ANDROID,
} from "../../../../constants";

const sizes = {
  sm: "48px",
  md: "90px",
};

const icons = {
  [ANDROID]: (width) => <AndroidIcon width={width} />,
  [ECOMMERCE]: (width) => <EcommerceIcon width={width} />,
  [IOS]: (width) => <IosIcon width={width} />,
  [SHOPIFY]: (width) => <ShopifyIcon width={width} />,
  [NEW_SHOPIFY]: (width) => <ShopifyIcon width={width} />,
  default: (width) => <EcommerceIcon width={width} />,
};

const ApplicationIcon = ({ applicationType, size = "sm" }) =>
  (icons[applicationType] || icons.default)(sizes[size]);

export default ApplicationIcon;
